import { Navigate, Outlet } from "react-router-dom";
import type { Permission } from "@dentacore/shared-types";

import { useCanAny } from "../auth/use-can";

/**
 * Bounces anyone holding none of `anyOf` back home (STORY-166).
 *
 * It asked `canAdminister` until roles arrived; System now opens to whoever
 * holds any of its permissions, and each pane inside asks for its own. **This
 * is presentation, not the permission check** (S3) — the API refuses on its
 * own, so a stale permission list can only show a pane that then explains why
 * it is refused.
 */
export function RequirePermission({ anyOf }: { anyOf: readonly Permission[] }): React.JSX.Element {
  const canAny = useCanAny();
  if (!canAny(anyOf)) return <Navigate to="/" replace />;
  return <Outlet />;
}
